module.exports = __webpack_public_path__ + "img/email.dc3b7bcf.svg";